module.exports = __webpack_public_path__ + "assets/img/aus_coloured.59bf516c.png";